export const PAYMENT_OPTIONS = {
	UPI: 'UPI',
	NETBANKING: 'NETBANKING',
};

export const PAYMENT_STATUS = {
	CAPTURED: 'captured',
	FAILED: 'failed',
	REFUND: 'refund',
};

export const PAYMENT_PRODUCT_NAMES = {
	EQUITY: 'equity',
	MF: 'mf',
}

export const PAYMENT_FLOWS = {
	ADD_FUNDS: 'ADD_FUNDS',
	SIP: 'SIP',
	ONETIME: 'ONETIME',
}

export const SIP_FLOWS = {
	buildwealth: 'buildwealth',
	savetaxsip: 'savetaxsip',
	saveforgoal: 'saveforgoal',
	diysip: 'diysip',
	sip: 'sip',
	goldsip: 'goldsip',
};

export const ONE_TIME_FLOWS = {
	buildwealthot: 'buildwealthot',
	savetax: 'savetax',
	investsurplus: 'investsurplus',
	diy: 'diy',
	onetime: 'onetime',
	gold: 'gold',
};

export const MF_SIP_FLOWS = [
	SIP_FLOWS.buildwealth,
	SIP_FLOWS.savetaxsip,
	SIP_FLOWS.saveforgoal,
	SIP_FLOWS.diysip,
	SIP_FLOWS.sip,
	SIP_FLOWS.goldsip,
];

export const MF_ONE_TIME_FLOWS = [
	ONE_TIME_FLOWS.buildwealthot,
	ONE_TIME_FLOWS.savetax,
	ONE_TIME_FLOWS.investsurplus,
	ONE_TIME_FLOWS.diy,
	ONE_TIME_FLOWS.onetime,
	ONE_TIME_FLOWS.gold,
];

export const INVEST_TYPES = {
	sip: 'sip',
	onetime: 'onetime',
};

export const UPI_PACKAGE_NAME_MAPPER = {
	'com.google.android.apps.nbu.paisa.user': 'Google Pay',
	'com.phonepe.app': 'PhonePe',
	'net.one97.paytm': 'Paytm',
	'com.paytmmall': 'Paytm Mall',
	'in.org.npci.upiapp': 'BHIM',
	'in.amazon.mShop.android.shopping': 'Amazon Pay',
	'com.csam.icici.bank.imobile': 'ICICI Imobile',
	'com.sbi.upi': 'SBI',
	'com.myairtelapp': 'MyAirtel App',
	'com.icicibank.pockets': 'ICICI Pockets',
	'com.snapwork.hdfc': 'HDFC Snapwork',
	'com.enstage.wibmo.hdfc': 'HDFC Wibmo',
	'com.mobikwik_new': 'Mobikwik',
	'com.upi.axispay': 'Axis Pay',
	'com.axis.mobile': 'Axis Mobile',
	'com.freecharge.android': 'Freecharge',
	'com.samsung.android.spaymini': 'SPayMini',
	'com.samsung.android.spay': 'SPay',
	'com.dreamplug.androidapp': 'Cred',
	'com.bankofbaroda.upi': 'Bank of Baroda',
	'com.whatsapp.w4b': 'WhatsApp Business',
	'com.fss.pnbpsp': 'PNB',
	'com.fss.unbipsp': 'UNBI',
	'com.mycompany.kvb': 'KVB',
	'com.fss.vijayapsp': 'Vijaya Bank',
	'com.dena.upi.gui': 'Dena Bank',
	'com.fss.jnkpsp': 'J&K Bank',
	'com.olive.kotak.upi': 'Kotak Bank',
	'com.bsb.hike': 'Hike',
	'com.fss.idfcpsp': 'IDFC PSP',
	'com.YesBank': 'Yes Bank',
	'com.abipbl.upi': 'ABIPBL',
	'com.microsoft.mobile.polymer': 'Polymer',
	'com.finopaytech.bpayfino': 'Fino',
	'com.mgs.obcbank': 'OBC',
	'com.upi.federalbank.org.lotza': 'Federal Bank',
	'com.mgs.induspsp': 'Indus Bank',
	'ai.wizely.android': 'Wizely',
	'com.olive.dcb.upi': 'DCB',
	'com.mgs.yesmerchantnative.prod': 'Yes Merchant',
	'com.dbs.in.digitalbank': 'DBS',
	'com.rblbank.mobank': 'RBL MoBank',
	'in.chillr': 'Chillr',
	'com.citrus.citruspay': 'CitrusPay',
	'com.SIBMobile': 'South Indian Bank',
	'com.mipay.wallet.in': 'MI Pay',
	'com.whatsapp': 'WhatsApp',
	'com.truecaller': 'Truecaller',
	'com.olacabs.customer': 'Ola',
	'com.gbwhatsapp': 'GB WhatsApp',
	'com.msf.angelmobile': 'Angel Mobile',
	'com.fundsindia': 'Funds India',
	'com.muthootfinance.imuthoot': 'iMuthoot',
	'com.angelbroking.angelwealth': 'Angel Wealth',
	'org.altruist.BajajExperia': 'Bajaj',
	'in.bajajfinservmarkets.app': 'Bajaj MARKETS',
};
